import React from "react";
import "./Service_pages.scss";
import img from "./services/dental_crown.png"; // Replace with actual path
import img2 from "./services/dental.png";
import { FaCheckCircle, FaTooth, FaMicroscope, FaSmile, FaShieldAlt,  } from 'react-icons/fa';
import { MdOutlineStarPurple500, MdOutlineHealthAndSafety } from "react-icons/md";
import { GiGoldBar } from "react-icons/gi";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { motion, AnimatePresence } from "framer-motion";
import { FiPlus, FiMinus } from "react-icons/fi";
import { IoDiamondOutline, IoShieldCheckmarkOutline, IoTimeOutline, IoSparklesOutline } from "react-icons/io5";

const DentalCrowns = () => {

    const types = [
        {
            title: "Zirconia Crowns",
            icon: <MdOutlineHealthAndSafety />,
            desc: "Zirconia crowns are extremely strong and durable, making them ideal for back teeth that endure strong chewing forces. They offer a perfect blend of high-end strength and natural aesthetics.",
        },
        {
            title: "Porcelain & Ceramic",
            icon: <FaTooth />,
            desc: "Porcelain crowns are known for their natural appearance and are commonly used for front teeth restorations. Ceramic crowns provide excellent aesthetics and are metal-free, ideal for patients with metal sensitivities.",
        },
        {
            title: "Porcelain-Fused-to-Metal (PFM)",
            icon: <MdOutlineStarPurple500 />,
            desc: "These crowns combine strength and aesthetics, providing both durability and a natural appearance. They use a metal substructure for stability with a porcelain layer for a tooth-like finish.",
        },
        {
            title: "Metal Crowns (Gold/Alloy)",
            icon: <GiGoldBar />,
            desc: "While less aesthetic, metal crowns are exceptionally durable and reliable. High-quality crown materials are designed to withstand daily chewing forces and provide long-term durability.",
        },
    ];

    const disadvantages = [
        {
            title: "Tooth Reduction",
            description: "The preparation process involves removing some natural tooth structure to ensure the crown fits properly, which is irreversible.",
        },
        {
            title: "Sensitivity",
            description: "Some patients may experience temporary sensitivity to hot or cold immediately after the procedure.",
        },
        {
            title: "Cost",
            description: "While an investment in long-term oral health, the cost of premium materials can be a factor. At Kosmix, we offer affordable options.",
        },
        {
            title: "Maintenance",
            description: "Crowns require good oral hygiene and regular checkups to prevent decay around the margins and maintain gum health.",
        },
        {
            title: "Not Always Ideal for Large Gaps",
            description: "If many teeth are missing, dental implants or bridges might be a more suitable long-term solution than single crowns.",
        },
    ];

    const benefits = [
        {
            category: "Restoration",
            benefit: "Long-Lasting Protection",
            description: "Crowns provide strong protection for weakened teeth, preventing further damage and fractures.",
        },
        {
            category: "Restoration",
            benefit: "Improved Chewing Function",
            description: "Crowns restore the ability to bite and chew comfortably, especially for teeth that were previously damaged or weak.",
        },
        {
            category: "Aesthetics",
            benefit: "Natural Appearance",
            description: "Modern crowns are designed to match the color and contour of natural teeth, making them virtually indistinguishable.",
        },
        {
            category: "Aesthetics",
            benefit: "Enhanced Smile Aesthetics",
            description: "Dental crowns improve the appearance of damaged, discolored, or misshapen teeth, contributing to a confident smile.",
        },
        {
            category: "Durability",
            benefit: "Durable and Reliable",
            description: "High-quality crown materials are designed to withstand daily chewing forces and provide long-term durability.",
        },
        {
            category: "Durability",
            benefit: "Lifespan of 10–15 Years",
            description: "With proper care, dental crowns can last 10–15 years or longer through consistent oral hygiene.",
        },
    ];

  

    const faqs = [
        {
            question: "How long do dental crowns usually last?",
            answer: "With proper care, dental crowns can last between 10 to 15 years. Maintaining good oral hygiene and regular dental checkups are key to their longevity."
        },
        {
            question: "Is the dental crown procedure painful?",
            answer: "No, the procedure is typically pain-free. We use local anesthesia to numb the area during tooth preparation. Some temporary sensitivity may occur after the procedure but subsides quickly."
        },
        {
            question: "Can a dental crown develop a cavity?",
            answer: "While the crown itself cannot decay, the natural tooth underneath and around the gumline still can. This is why brushing and flossing are essential to protect the supporting tooth."
        },
        {
            question: "What is the difference between Zirconia and Porcelain crowns?",
            answer: "Zirconia crowns are extremely strong and chip-resistant, making them ideal for back teeth. Porcelain crowns offer excellent aesthetics and can be perfectly matched to front teeth."
        },
        {
            question: "How do I care for my new dental crown?",
            answer: "Treat it like a natural tooth! Brush twice a day, floss daily, and avoid biting on extremely hard objects like ice or hard candy to prevent damage."
        }
    ];

    const [activeIndex, setActiveIndex] = React.useState(null);

    return (
        <>
            <div className="service1-section">
                <Helmet>
                    <title>Dental Crowns in HSR Layout | Zirconia & Porcelain Crowns Bengaluru</title>
                    <meta
                        name="description"
                        content="Restore your tooth's strength with advanced dental crowns at Kosmix Dental Clinic, HSR Layout. Custom-designed Zirconia and Porcelain crowns for a natural smile."
                    />
                    <link
                        rel="canonical"
                        href="https://www.kosmixdentalclinic.com/services/dental-crowns-in-hsr-layout"
                    />
                </Helmet>

                <div className="hero">
                    <h1 className="service1-title-text" data-aos="fade-down" data-aos-delay="200" style={{ fontFamily: 'initial' }}>
                        Restore Strength and Beauty with Advanced Dental Crowns
                    </h1>

                    <div className="hero-content">
                        <div className="hero-image" data-aos="zoom-in-right" data-aos-delay="200" data-aos-duration="800">
                            <img src={img} alt="Dental Crown Treatment" />
                        </div>

                        <div className="hero-text" data-aos="zoom-in-left" data-aos-delay="200" data-aos-duration="800">
                            <p>
                                Dental crowns play an important role in restorative dentistry by protecting weakened teeth and restoring their natural appearance. When a tooth becomes damaged due to decay, fractures, or wear, a crown acts as a protective shield that covers the entire visible portion of the tooth.
                            </p>
                            <p>
                                At <strong>Kosmix Dental Clinic</strong> in HSR Layout, Bengaluru, our dentists design custom dental crowns that look natural while providing exceptional durability. Using advanced technology and high-quality materials, we ensure every crown fits comfortably and blends seamlessly with your smile.
                            </p>
                            <p>
                                Dental crowns not only restore the function of damaged teeth but also improve the overall aesthetics of your smile. With modern techniques, crowns are designed to mimic natural teeth in color, shape, and strength.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="content" data-aos="fade-up" data-aos-delay="300" >
                    <SectionTitle title="Common Dental Problems Treated with Crowns" />
                    <div className="text_first" >
                        <p1>
                            Dental crowns are recommended for several restorative and cosmetic dental concerns. They help protect teeth from further damage while restoring their functionality. Whether it is for protection after a root canal or fixing a cracked tooth, crowns provide a permanent solution.
                        </p1>
                    </div>
                </div>

                <div className="crown-redesign-suite">
                    <section className="crown-issue-hub">
                        <div className="content" data-aos="fade-up">
                            <SectionTitle title="Restorative Solutions Tailored for You" />
                            <p className="text_first">
                                Dental crowns address several restorative and cosmetic concerns, acting as a permanent shield for your oral health.
                            </p>
                        </div>

                        <div className="issue-visual-grid">
                            {[
                                { title: "Severely Decayed Teeth", desc: "When cavities exceed the limits of fillings, a crown preserves structural integrity.", icon: <FaMicroscope /> },
                                { title: "Cracked or Fractured Teeth", desc: "Stabilizes teeth damaged by trauma, preventing further escalation of cracks.", icon: <FaShieldAlt /> },
                                { title: "Worn-Down Teeth", desc: "Restores height and strength to teeth eroded by attrition or bruxism.", icon: <FaTooth /> },
                                { title: "Post-Root Canal Care", desc: "Provides vital protection for brittle teeth following root canal therapy.", icon: <MdOutlineHealthAndSafety /> },
                                { title: "Cosmetic Enhancements", desc: "Refines the aesthetics of discolored or uneven teeth for a flawless smile.", icon: <FaSmile /> },
                            ].map((issue, idx) => (
                                <motion.div 
                                    className="issue-feature-box" 
                                    key={idx}
                                    whileHover={{ scale: 1.02 }}
                                    data-aos="fade-up"
                                    data-aos-delay={idx * 100}
                                >
                                    <div className="box-number">0{idx + 1}</div>
                                    <div className="box-icon">{issue.icon}</div>
                                    <div className="box-content">
                                        <h3>{issue.title}</h3>
                                        <p>{issue.desc}</p>
                                    </div>
                                </motion.div>
                            ))}
                        </div>
                    </section>

                    <section className="premium-crown-journey">
                        <div className="journey-bg-text">PROCESS</div>
                        <div className="content" data-aos="fade-up">
                            <SectionTitle title="The Smile Restoration Voyage" />
                            <p className="text_first">A meticulous protocol designed for precision, comfort, and aesthetic perfection.</p>
                        </div>

                        <div className="journey-timeline">
                            {[
                                { step: "01", title: "Diagnostic Mapping", desc: "Digital 3D diagnostics to plan your custom restoration.", icon: "🩺" },
                                { step: "02", title: "Precision Sculpting", desc: "Conservative preparation to make space for the crown.", icon: "🦷" },
                                { step: "03", title: "Intraoral Scanning", desc: "Advancing beyond messy impressions with digital precision.", icon: "✨" },
                                { step: "04", title: "Temporary Defense", desc: "Protecting your tooth while your final crown is crafted.", icon: "🛡️" },
                                { step: "05", title: "Final Integration", desc: "Meticulous bonding and occlusion check for a perfect fit.", icon: "✅" },
                            ].map((item, idx) => (
                                <div className="journey-node" key={idx} data-aos="fade-right" data-aos-delay={idx * 150}>
                                    <div className="node-marker">
                                        <div className="marker-dot"></div>
                                        <div className="marker-line"></div>
                                    </div>
                                    <div className="node-card">
                                        <div className="node-icon">{item.icon}</div>
                                        <div className="node-info">
                                            <span className="node-step">Phase {item.step}</span>
                                            <h3>{item.title}</h3>
                                            <p>{item.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="crown-material-showcase">
                        <div className="content" data-aos="fade-up">
                            <SectionTitle title="Artistry in Crown Materials" />
                            <p className="text_first">We select only the highest-grade biocompatible materials for your restorative needs.</p>
                        </div>

                        <div className="material-mosaic">
                            {types.map((material, idx) => (
                                <div className="material-brick" key={idx} data-aos="zoom-in" data-aos-delay={idx * 200}>
                                    <div className="brick-inner">
                                        <div className="brick-front">
                                            <div className="brick-icon">{material.icon}</div>
                                            <h3>{material.title}</h3>
                                        </div>
                                        <div className="brick-back">
                                            <p>{material.desc}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="crown-performance-analysis">
                        <div className="content" data-aos="fade-up">
                            <SectionTitle title="The Advantages of Modern Crowns" />
                        </div>
                        <div className="analysis-grid">
                            {benefits.map((benefit, idx) => (
                                <div className="analysis-item" key={idx} data-aos="fade-up" data-aos-delay={idx * 50}>
                                    <div className="analysis-icon"><FaCheckCircle /></div>
                                    <div className="analysis-text">
                                        <h4>{benefit.benefit}</h4>
                                        <p>{benefit.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="crown-considerations">
                         <div className="content" data-aos="fade-up">
                            <SectionTitle title="Clinical Considerations" />
                            <p className="text_first">Understanding the full spectrum of restorative dental care.</p>
                        </div>
                        <div className="considerations-mosaic">
                            {disadvantages.map((item, idx) => (
                                <div className="con-card" key={idx} data-aos="fade-up" data-aos-delay={idx * 100}>
                                    <div className="con-icon"><FiMinus /></div>
                                    <div className="con-text">
                                        <h4>{item.title}</h4>
                                        <p>{item.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="aesthetic-hero-section">
                        <div className="aesthetic-content">
                            <div className="aesthetic-image" data-aos="fade-right">
                                <img src={img2} alt="Clinic Facility" />
                                <div className="image-badge">KOSMIX CARE</div>
                            </div>
                            <div className="aesthetic-text" data-aos="fade-left">
                                <SectionTitle title="Visit the Best Clinic for Crowns" />
                                <p>
                                    Don’t let a damaged tooth affect your quality of life. At <strong>Kosmix Dental Clinic</strong>, our specialists blend technology with artistry to restore your smile.
                                </p>
                                <div className="highlight-points">
                                    <div className="hp-item"><IoDiamondOutline /> Premium Materials</div>
                                    <div className="hp-item"><IoShieldCheckmarkOutline /> 10-15 Year Lifespan</div>
                                    <div className="hp-item"><IoTimeOutline /> Fast Procedure</div>
                                    <div className="hp-item"><IoSparklesOutline /> Natural Look</div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="dental-faq-section">
                        <div className="content" data-aos="fade-up">
                            <SectionTitle title="Frequently Asked Questions" />
                            <p className="text_first">Everything you need to know about your restorative journey.</p>
                        </div>

                        <div className="faq-accordion-container">
                            {faqs.map((faq, index) => (
                                <div 
                                    className={`faq-item ${activeIndex === index ? 'active' : ''}`} 
                                    key={index}
                                    onClick={() => setActiveIndex(activeIndex === index ? null : index)}
                                >
                                    <div className="faq-question">
                                        <h3>{faq.question}</h3>
                                        <div className="faq-toggle">
                                            {activeIndex === index ? <FiMinus /> : <FiPlus />}
                                        </div>
                                    </div>
                                    <AnimatePresence>
                                        {activeIndex === index && (
                                            <motion.div 
                                                className="faq-answer"
                                                initial={{ height: 0, opacity: 0 }}
                                                animate={{ height: "auto", opacity: 1 }}
                                                exit={{ height: 0, opacity: 0 }}
                                                transition={{ duration: 0.3 }}
                                            >
                                                <p>{faq.answer}</p>
                                            </motion.div>
                                        )}
                                    </AnimatePresence>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>

                <section className="cta-section" data-aos='zoom-in'>
                    <div className="cta-content">
                        <h2>Restore Your Smile <span>Today!</span></h2>
                        <p>Experience advanced dental crown treatment with cutting-edge technology and top-rated care at Kosmix Dental Clinic.</p>
                        <div className="cta-buttons">
                            <Link to="/#appointment">
                                <button className="btn-primary">Book Appointment</button>
                            </Link>
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

const SectionTitle = ({ title }) => (
    <h2 className="section-title">{title}</h2>
);

export default DentalCrowns;